<html>

<head>
    <title>Show Payment Page</title>
</head>

<body>

    <h1 class="global-h1" style="text-align: center;">Please do not refresh this page...</h1>

    <form class="global-form" #form ngNoForm method="post" name="redirect" action="https://securegw.paytm.in/theia/api/v1/showPaymentPage?mid=licUxm57727072173022&orderId=C00001" name="paytm">
        <table border="1">
            <tbody>
                <input class="global-input" type="hidden" name="mid" value="licUxm57727072173022">
                <input class="global-input" type="text" name="orderId" value="C00001">
                <input class="global-input" type="text" name="txnToken" value="oNTtdNg/KMAYHc2IyYhnQicxnE7Gyc6zZc5pD08zv7ua7gwRRPWkY8joVzYI5zIrBp80JLyXSbtWB89QpaFqQo/AFw6C0du1Q5+WTKhvt8I=">
            </tbody>
        </table>
        <button style="font-size: 15px; margin: auto; width: 50%" type="button" (click)="payWithPayTM()" class="subscribe btn btn-primary btn-block global-button">
            Pay thorugh PAYTM &nbsp;&nbsp;</button>

    </form>
</body>

</html>